import UpdateSequenceNumberRequestModelBase from '../_generated/modelBases/update-sequence-number-request-model-base';

export default class UpdateSequenceNumberRequestModel extends UpdateSequenceNumberRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
